import React from 'react';
import { Sparkles } from 'lucide-react';
interface MatchContextProps {
  visible: boolean;
}
export function MatchContext({
  visible
}: MatchContextProps) {
  if (!visible) return null;
  return <section className="px-6 md:px-12 max-w-6xl mx-auto mt-6 mb-8 relative z-20" data-id="element-153">
      <div className="bg-brand-forest/10 border border-brand-forest/20 rounded-2xl px-6 py-5" data-id="element-154">
        <div className="flex items-start gap-3" data-id="element-155">
          <div className="w-8 h-8 rounded-full bg-brand-forest/20 flex items-center justify-center shrink-0 mt-0.5" data-id="element-156">
            <Sparkles size={16} className="text-brand-forest" data-id="element-157" />
          </div>
          <div data-id="element-158">
            <p className="text-sm font-medium text-brand-dark mb-1" data-id="element-159">
              Why you were matched
            </p>
            <p className="text-sm text-brand-muted leading-relaxed" data-id="element-160">
              Krystle has closed{' '}
              <span className="font-mono text-brand-dark" data-id="element-161">62 homes</span> in
              Redlands (92373) over the past 24 months at{' '}
              <span className="font-mono text-brand-dark" data-id="element-162">
                3.8% above market
              </span>
              , with an average of{' '}
              <span className="font-mono text-brand-dark" data-id="element-163">14 days</span> on
              market — 11 days faster than the local median. Her price range
              sweet spot (
              <span className="font-mono text-brand-dark" data-id="element-164">$385K–$1.4M</span>)
              aligns with your estimated home value.
            </p>
          </div>
        </div>
      </div>
    </section>;
}